import { defineStore } from "pinia";
import { ref } from "vue";
import type { UserPermissions } from "@/types/partner";

export const useSessionStore = defineStore(
    "session",
    () => {
        const userEmail = ref<string | null>(null);
        const permissions = ref<UserPermissions | null>(null);
        const isAuthenticated = ref(false);

        function setUserEmail(email: string | null) {
            userEmail.value = email;
        }

        function setPermissions(value: UserPermissions | null) {
            permissions.value = value;
        }

        function setIsAuthenticated(value: boolean) {
            isAuthenticated.value = value;
        }

        function clearUserSession() {
            userEmail.value = null;
            permissions.value = null;
            isAuthenticated.value = false;
        }

        return {
            userEmail,
            permissions,
            isAuthenticated,
            setUserEmail,
            setPermissions,
            setIsAuthenticated,
            clearUserSession,
        };
    },
    {
        persist: [
            {
                pick: ["userEmail", "permissions"],
                storage: localStorage,
            },
            {
                pick: ["userEmail", "isAuthenticated"],
                storage: sessionStorage,
            },
        ],
    },
);
